import VerticalLine from "@/assets/images/varticalLine.svg";
import { CardImages, CardNetworkIcon } from "@/modules/card/common/constants";
import type { CardClassification, CardNetwork } from "@/modules/card/common/enum";
import { DATE_FORMAT } from "@/shared/common/constants";
import { CloudflareAsset } from "@/shared/common/enums";
import { Amount, CloudFlareImage } from "@/shared/components";
import { formatCardNumber, formatDate } from "@/shared/helpers";
import { ButtonIcon } from "@ab.uitools/ui-library/components/ButtonIcon";
import { Copy } from "@ab.uitools/ui-library/components/Copy";
import { Image } from "@ab.uitools/ui-library/components/Image";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useMemo, useState } from "react";

interface Props {
  balance: number;
  number: string;
  holder: string;
  currency: string;
  expirationDate: string;
  cardClassification: CardClassification;
  cardNetwork: CardNetwork;
}

export const CardImage = ({
  number,
  holder,
  balance,
  currency,
  cardNetwork,
  expirationDate,
  cardClassification,
}: Props) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const formatedExpirationDate = useMemo(() => {
    const month = formatDate(expirationDate, DATE_FORMAT.MM);
    const year = formatDate(expirationDate, DATE_FORMAT.YY);
    return `${month}/${year}`;
  }, [expirationDate]);

  const cardImage = cardClassification && CardImages[cardClassification] || CloudflareAsset.DefaultCard;
  const cardNetworkIcon = cardNetwork ? CardNetworkIcon[cardNetwork] : null;

  return (
    <div className="full-width flexbox justify-content--center card-image-body-wrapper">
      <div className="flexbox justify-content--center position-relative">
        <div className="card-image-body">
          <CloudFlareImage className="card-classification-image" path={cardImage}/>
          {cardNetworkIcon && (
            <CloudFlareImage className="card-network-image" path={cardNetworkIcon}/>
          )}
          <div className="full-width full-height card-image-info-wrapper">
            <Amount
              className="card-balance"
              position="left"
              type="inverse"
              size="large"
              weight="bolder"
              floatWeight="semibold"
              amount={balance}
              currency={currency}
            />
            <div className="flexbox align-items--center">
              <Text size="medium" weight="semibold" type="inverse" className="pr-4">
                {formatCardNumber({ card: number || "", isHidden: !isVisible })}
              </Text>
              {isVisible && (
                <Copy type="inverse" size="medium" text={number || ""}/>
              )}
              <ButtonIcon
                onClick={() => setIsVisible(!isVisible)}
                data-testid="show-hide-card-number"
                data-ga-id="show-hide-card-number"
                data-ga-action="Show or hide card number"
                iconProps={{
                  Component: (props: ISVGIconProps) => isVisible ? (
                    <CloudFlareImage {...props} path={CloudflareAsset.EyeCloseLight}/>
                  ) : (
                    <CloudFlareImage {...props} path={CloudflareAsset.EyeOpenLight}/>
                  ),
                  type: "inverse"
                }}/>
            </div>
            <div className="flexbox mt-10">
              <Text type="inverse">{holder}</Text>
              <Image className="ml-6 mr-6" imagePath={VerticalLine}/>
              <Text type="inverse">{formatedExpirationDate}</Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
